module.exports = __webpack_public_path__ + "img/Magnify.f29c4679.gif";